import React from 'react';
import PropTypes from 'prop-types';
import Selector from 'react-select';
import { connect } from 'react-redux';

import {getFeaturesPlans} from 'actions';

class PlanSelector extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			tags : [],
			search_options : []
		}

		this.available_plans = [];

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleFilterOptions = this.handleFilterOptions.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
	}

	handleInputChange(inputValue) {
		let found_plans = this.available_plans.filter(plan => (
			plan.search_terms.find(term => (
				term.includes(inputValue)
			))
		))

		let options = found_plans.map(plan => {
			return Object.assign({}, {value : plan}, {label : plan.name})
		})

		this.setState({search_options : options})
	}

	handleFilterOptions(options) {
		return options;
	}

	handleValueChange(newValue) {
		let plans = newValue.map(v => v.value)
		// Needed to conform to handleChange function in userForm
		let event = {
			target : {
				value : plans,
				name : 'plans'
			}
		}

		this.setState({tags : newValue});
		this.props.handleChange(event);
	}

	componentWillMount() {
		this.props.dispatch(getFeaturesPlans('', (err, plans) => {
			this.available_plans = plans;
		}))

		let current_plans = (this.props.currentPlans) ? 
			this.props.currentPlans.map(plan => {
		 		return Object.assign({}, {value : plan}, {label : plan.name})
			}) : []

		this.setState({tags : current_plans})
	}

	render() {
		let container_class_name = 
			this.props.containerClassName ? this.props.containerClassName : '';

		return (
			<div 
				className={container_class_name}>
				<Selector 
					onInputChange={this.handleInputChange}
					options={this.state.search_options}
					value={this.state.tags}
					onBlurResetsInput={false}
					filterOptions={this.handleFilterOptions}
					onChange={this.handleValueChange}
					multi={true}
					delimiter=';'
					/>
			</div>
		)
	}
}

export default connect((state) => state)(PlanSelector);


// WEBPACK FOOTER //
// ./src/browser/components/ui/planSelector/planSelectorContainer.js